import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableSortLabel,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { stableSort, compareByNumericProp } from '../../../utils/comparators';
import { useWindowSizing } from '../../util/WindowSizing';
import './SummaryTable.css';

/**
 * Table wrapper component which handles column variants for window size and controls sorting
 */
const SummaryTable = ({ table: { title, cols, rows }, defaultOrderBy }) => {
  const { isSmallScreen } = useWindowSizing();
  const [{ order, orderBy }, setSort] = useState({ orderBy: defaultOrderBy, order: 'asc' });
  const createSortHandler = (sortColumn) => () => {
    // first click on a column sort label sorts it by 'ascending' regardless of last order
    const isAsc = order === 'asc' && orderBy === sortColumn;
    setSort({ orderBy: sortColumn, order: isAsc ? 'desc' : 'asc' });
  };
  const comparator = (a, b) => compareByNumericProp(orderBy, order)(a.values, b.values);
  return (
    <div>
      {title && <Typography className="SummaryTable-title">{title}</Typography>}
      <Table className="SummaryTable">
        {cols.some((c) => c.name && c.name.length > 0) && (
          <TableHead>
            <TableRow>
              {cols.map((col, colIndex) => {
                if ((col.hideOnMobile && isSmallScreen) || !col.name || col.name.length === 0) {
                  return null;
                }
                if (col.noSort) {
                  return <TableCell key={col.name}>{col.name}</TableCell>;
                }
                const isSort = orderBy === colIndex;
                return (
                  <TableCell key={col.name} sortDirection={isSort ? order : false}>
                    <TableSortLabel
                      active={isSort}
                      direction={isSort ? order : 'asc'}
                      onClick={createSortHandler(colIndex)}
                    >
                      {col.name}
                    </TableSortLabel>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {stableSort(rows, comparator).map((row) => (
            <TableRow key={row.id} className="wrap-style">
              {row.values.map((value, valIndex) => {
                if (cols[valIndex].hideOnMobile && isSmallScreen) {
                  return null;
                }
                return (
                  <TableCell key={`${row.id}-${cols[valIndex].name}`} className="wrap-style">
                    {value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

SummaryTable.defaultProps = {
  defaultOrderBy: 0, // column index to sort on by default
};

export default SummaryTable;
